/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const NatArc = require('../types/NatArc')
const PositionCercleCercle = require('../types/PositionCercleCercle')
const PositionRelative = require('../types/PositionRelative')
const kernel = require('../kernel/kernel')
const CElementLigne = require('./CElementLigne')
module.exports = CCercle

/**
 * Classe ancêtre de tous les cercles et arcs de cercle.
 * @constructor
 * @extends CElementLigne
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Color} couleur : La couleur.
 * @param {Boolean} masque : true si l'objet est masqué.
 * @param {mtg32.StyleTrait} style : Le style de tracé.
 * @returns {CCercle}
 */
function CCercle (listeProprietaire, impProto, estElementFinal, couleur,
  masque, style) {
  if (arguments.length === 0) return; // Ajout version 4.9.9.4
  if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);
  else CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur,
      true, 0, 0, masque, "", 16, style);
}
CCercle.prototype = new CElementLigne();
CCercle.prototype.constructor = CCercle;
CCercle.prototype.superClass = "CElementLigne";
CCercle.prototype.className = "CCercle";

CCercle.prototype.setClone = function(ptel) {
  CElementLigne.prototype.setClone.call(this,ptel);
  this.centre_x = ptel.centre_x;
  this.centre_y = ptel.centre_y;
  this.rayon = ptel.rayon;
  /* Supprimé version 5.2. Ne sert pas
  this.xCarre1 = ptel.xCarre1;
  this.yCarre1 = ptel.yCarre1;
  this.xCarre2 = ptel.xCarre2;
  this.yCarre2 = ptel.yCarre2;
  */
  this.horsFenetre = ptel.horsFenetre;
};
/**
 * Fonction renvoyant true si le point de coordonnées (xt,yt) est sur l'objet.
 * true par défaut.
 * A redéfinir pour les arcs de cercle.
 * @param {Float} xt : l'abscisse du point testé.
 * @param {Flaot} yt : L'ordonnée du point testé.
 * @returns {Boolean}
 */
CCercle.prototype.surArc = function(xt,yt) {
  return true; // true pour un vrai cercle
};
/**
 * Fonction fournissant la position relative du cercle par rapport à elg
 * @param {type} elg
 * @param {type} bperpendiculaires : : renvoie par getValue true si des droites
 * sont perpendiculaires. Ici false.
 * @returns {PositionRelative}
 */
CCercle.prototype.positionRelative = function(elg, bperpendiculaires){
  if (elg.estDeNature(NatObj.NTtPoint)) {
    bperpendiculaires.setValue(false);
    if (kernel.appartientCercle(this, elg.x, elg.y) && this.surArc(elg.x, elg.y)) return PositionRelative.appartient;
    else return PositionRelative.nappartient;
  }
  else {
    if (elg.estDeNature(NatObj.NTtCercle)) {
      bperpendiculaires.setValue(false);
      // CCercle cercle = (CCercle) elg;
      var point1 = {};
      var point2 = {};
      var position = kernel.intersectionCercleCercle(this.centre_x, this.centre_y, this.rayon,
        elg.centre_x, elg.centre_y, elg.rayon, point1, point2);
      switch (position) {
        case PositionCercleCercle.Vide : return PositionRelative.vide;
        case PositionCercleCercle.Confondus :
          if (this.estDeNature(NatObj.NCercle) && elg.estDeNature(NatObj.NCercle)) return PositionRelative.confondus;
          else return PositionRelative.memeSupportCercle;
        case PositionCercleCercle.Tangents:
          if (this.surArc(this.point1.x, this.point1.y) && elg.surArc(this.point1.x, this.point1.y)) return PositionRelative.tangents;
          else return PositionRelative.vide;
        case PositionCercleCercle.Secants :
          var b1 = this.surArc(this.point1.x, this.point1.y) && elg.surArc(this.point1.x, this.point1.y);
          var b2 = this.surArc(this.point2.x, this.point2.y) && elg.surArc(this.point2.x, this.point2.y);
          if (b1 && b2) return PositionRelative.secants2Point;
          if (b1 || b2) return PositionRelative.secants1Point;
          return PositionRelative.vide;
        default : return PositionRelative.vide; // Pour satisfairele compilateur
      }
    }
    else return elg.positionRelative(this, bperpendiculaires);
  }
};
CCercle.prototype.positionne = function(infoRandom, dimfen) {
  // devra être appelée par tous les descendants de cercle.positionne
  // pour vérifier que le rayon est positif
  this.existe = (this.rayon > 0);
  if (this.existe) this.horsFenetre = !dimfen.testCercleDansFen(this.centre_x, this.centre_y, this.rayon);

  /* Modifié version 5.2. Algotithme non correct
  var rayon2 = this.rayon*this.rayon;
  d1 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, 0, 0);
  d2 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, 0, dimfen.y);
  d3 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, dimfen.x, 0);
  d4 = kernel.distancePointPointCarre(this.centre_x, this.centre_y, dimfen.x, dimfen.y);
  if ((rayon2 >= d1) && (rayon2 >= d2) && (rayon2 >= d3) && (rayon2 >= d4)) {
    this.horsFenetre = true;
    return;
  }
  if (!dimfen.dansFenetre(this.centre_x, this.centre_y)) {
    // On calcule les distances du centre aux quatre côtés de la fenêtre.
    // Si le rayon est inférieur à la plus petite des quatre, le cercle n'est pas visible
    d1 = Math.abs(this.centre_y);
    d2 = Math.abs(this.centre_y - dimfen.y);
    d3 = Math.abs(this.centre_x);
    d4 = Math.abs(this.centre_x - dimfen.x);
    if ((this.rayon <= d1) && (this.rayon <= d2) && (this.rayon <= d3) && (this.rayon <= d4)) {
      this.horsFenetre = true;
      return;
    }
  }
  /* Supprimé version 5.2. Ne sert pas
  this.xCarre1 = this.centre_x - this.rayon;
  this.yCarre1 = this.centre_y - this.rayon;
  this.xCarre2 = this.centre_x + this.rayon;
  this.yCarre2 = this.centre_y + this.rayon;
  */
  // this.horsFenetre = false;
};
CCercle.prototype.createg = function() {
  /* Modifié version mtgApp
  var g = document.createElementNS(kernel.svgns,"circle");
  g.setAttribute("cx",this.centre_x);
  g.setAttribute("cy",this.centre_y);
  g.setAttribute("r",this.rayon);
  var style = "";
  var stroke = this.style.stroke;
  if (stroke.length !== 0) style += "stroke-dasharray:"+stroke+";";
  var strokewidth = this.style.strokeWidth;
  style += "stroke-width:"+strokewidth+";";
  style += "stroke:"+this.color+";";
  style += "fill:none";
  g.setAttribute("style", style);
  g.setAttribute("pointer-events", "none");
  return g;
  */
  var style = "";
  var stroke = this.style.stroke;
  if (stroke.length !== 0) style += "stroke-dasharray:"+stroke+";";
  var strokewidth = this.style.strokeWidth;
  style += "stroke-width:"+strokewidth+";";
  style += "stroke:"+this.color+";";
  style += "fill:none";

  return kernel.cens("circle",{
    cx : this.centre_x,
    cy : this.centre_y,
    r : this.rayon,
    style : style,
    "pointer-events" : "none"
  });
};
CCercle.prototype.hasg = function(masquage, memeMasque = false) {
  return this.existe && !this.horsFenetre && (memeMasque || !(this.masque && masquage));
};
CCercle.prototype.horsCadre = function() {
  return this.horsFenetre;
};
CCercle.prototype.trace = function(svg, couleurFond, transparence) {
  // if ((kernel.testToile(this.xCarre1,this.yCarre1)) && (kernel.testToile(this.xCarre2,this.yCarre2))){
  var g = this.createg();
  g.setAttribute("id", this.id);
  svg.appendChild(g);
  this.g = g;
};
CCercle.prototype.update = function() {
  var g = this.g;
  g.removeAttribute("cx");
  g.removeAttribute("cy");
  g.removeAttribute("r");
  g.setAttribute("cx",this.centre_x);
  g.setAttribute("cy",this.centre_y);
  g.setAttribute("r",this.rayon);
};
CCercle.prototype.abscisseMinimale = function() {
  return 0;
};
CCercle.prototype.abscisseMaximale = function() {
  return 2*Math.PI;
};
CCercle.prototype.abscisseCurviligne = function(ang){
  return ang;
};
CCercle.prototype.natureArc = function() {
  return NatArc.ArcCercle;
};
CCercle.prototype.dansFen = function() { // Test d'existence car on peut créer un cercle qui n'existe pas
  return this.existe && !this.horsFenetre;
};
CCercle.prototype.getNature = function() {
  return NatObj.NCercle;
};
// Utilis version mtgApp
CCercle.prototype.setRayon = function(ray) {
  this.rayon = ray;
};

CCercle.prototype.pointInterieur = function(x, y) {
  return (kernel.distancePointPoint(x, y, this.centre_x, this.centre_y) <= this.rayon);
};
CCercle.prototype.chaineDesignation = function() {
  return "desCercle";
};

